import { createApp } from 'vue';

import '@/app/assets/styles/index.css';

import { initQuickQuoteApp } from './init';
import QuickQuoteApp from './QuickQuoteApp.vue';
import { loadQuickQuoteConfig } from './runtime-config';

const bootstrap = async (): Promise<void> => {
	await loadQuickQuoteConfig();

	const app = createApp(QuickQuoteApp);
	initQuickQuoteApp(app);
	app.mount('#app');
};

void bootstrap();
